import { FEATURED_ITEMS_LOAD } from 'components/admin/featured-items/store/action-types';

const initialState = {
  featuredItems: [],
};

export default function featuredItemsDataReducer(state = initialState, action) {
  switch (action.type) {
    case FEATURED_ITEMS_LOAD:
      return {
        ...state,
        featuredItems: action.payload,
      };

    default:
      return state;
  }
}
